// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cDu8e","field":"styles_field__diIp3","fieldCol":"styles_fieldCol__UmJN_","diffCol":"styles_diffCol__1tucu","diff":"styles_diff__-pxL2"};